import packageJson from '../package.json';

const name = packageJson.name;
const version = packageJson.version;

export enum Project {
  SupplyChainManagement = 'supply-chain-management',
  SuppliersManagement = 'suppliers-management',
}

export enum Product {
  SupplyChainManagement = 'Drop Shipping Management',
  SuppliersManagement = 'Drop Shipping System',
}

export enum Env {
  Local = 'local',
  UAT = 'uat',
  Production = 'production',
}

const project = process.env.REACT_APP_PROJECT;
const product =
  project === Project.SupplyChainManagement
    ? Product.SupplyChainManagement
    : project === Project.SuppliersManagement
    ? Product.SuppliersManagement
    : '';

export const config = {
  product: product,
  project: project,
  reactAppVersion: version,
  productHeader: `${name}/${version}`,
  publicUrl: '',
  apiUrl: process.env.REACT_APP_API_URL || `${window.location.origin}/api`,
  authUrl: process.env.REACT_APP_AUTH_URL,
  googleOauth: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID as string,
  DateTime: {
    full: 'YYYY-MM-DD HH:mm',
    date: 'YYYY-MM-DD',
    time: 'HH:mm:ss',
    hhmm: 'HH:mm',
    fileName: 'YYYY-MM-DD[_]HH-mm-ss',
  },
  reactAppEnv: process.env.REACT_APP_ENV || Env.Production,
};

export default config;
